(function () {
  if (window.valeCardSwatches) return;
  window.valeCardSwatches = true;

  function container(el) {
    return el.closest('.card__container');
  }

  function cardImg(el) {
    var c = container(el);
    return c ? c.querySelector('.card__picture img.card__img:not(.card__img--hover)') : null;
  }

  function cardTitle(el) {
    var c = container(el);
    return c ? c.querySelector('.card__title') : null;
  }

  function show(chip) {
    var img = cardImg(chip);
    if (img && chip.dataset.valeSrc) {
      if (img.dataset.valeOrigSrc === undefined) {
        img.dataset.valeOrigSrc = img.getAttribute('src') || '';
        img.dataset.valeOrigSrcset = img.getAttribute('srcset') || '';
      }
      img.setAttribute('srcset', chip.dataset.valeSrcset || '');
      img.setAttribute('src', chip.dataset.valeSrc);
    }
    var title = cardTitle(chip);
    if (title && chip.dataset.valeTitle) {
      if (title.dataset.valeOrigTitle === undefined) {
        title.dataset.valeOrigTitle = title.textContent.trim();
      }
      title.textContent = chip.dataset.valeTitle;
    }
  }

  function reset(list) {
    var img = cardImg(list);
    if (img && img.dataset.valeOrigSrc !== undefined) {
      img.setAttribute('srcset', img.dataset.valeOrigSrcset);
      img.setAttribute('src', img.dataset.valeOrigSrc);
    }
    var title = cardTitle(list);
    if (title && title.dataset.valeOrigTitle !== undefined) {
      title.textContent = title.dataset.valeOrigTitle;
    }
  }

  function chipFrom(e) {
    return e.target && e.target.closest ? e.target.closest('.vale-card-swatches__chip') : null;
  }

  function leave(e) {
    var list = e.target && e.target.closest ? e.target.closest('.vale-card-swatches') : null;
    if (list && !(e.relatedTarget && list.contains(e.relatedTarget))) reset(list);
  }

  document.addEventListener('mouseover', function (e) { var c = chipFrom(e); if (c) show(c); });
  document.addEventListener('focusin', function (e) { var c = chipFrom(e); if (c) show(c); });
  document.addEventListener('mouseout', leave);
  document.addEventListener('focusout', leave);
})();